module.exports = __webpack_public_path__ + "img/y_2008_hover.87d90ca1.png";